import React from 'react';
import Conditional from '../../common/conditional';

import * as models from '../../../utils/models';
import * as utils from '../../../utils/utilities';

import classNames from './style.module.scss';

interface ProjectCommentsProps {
	comments: models.ProjectComment[];
}

const ProjectComments: React.FC<ProjectCommentsProps> = ({ comments }) => {
	return (
		<div className={classNames.comment}>
			<div className="bg-light border p-3">
				<h4 className={classNames.commentHeader}>
					<i className="bi bi-info-square-fill"></i>
					<span>Comment History</span>
				</h4>

				<ul className={classNames.commentHistory}>
					{comments.map((comment) => {
						const isRejected = utils.matchPhrases(comment.action, 'rejected');

						return (
							<li className={classNames.commentHistoryItem} key={comment._id}>
								<div className={classNames.commentHistoryItemIcon}>
									<i className="bi bi-chat-text-fill mx-2"></i>
								</div>

								<div className={classNames.commentHistoryItemDetails}>
									<div className={classNames.commentHistoryItemDetailsComment}>
										{comment.comment || 'N/A'}
									</div>

									<div className={classNames.commentHistoryItemDetailsUser}>
										{comment.action} by {comment.commentByName}
									</div>

									<Conditional
										isVisible={isRejected || comment.rejectReason !== null}
									>
										<div className={classNames.commentHistoryItemDetailsUser}>
											<span>Change to </span>
											<span
												className={classNames.commentHistoryItemDetailsDanger}
											>
												{comment.rejectReason}
											</span>{' '}
											requested from{' '}
											<span
												className={classNames.commentHistoryItemDetailsDanger}
											>
												{comment.oldValue}
											</span>
										</div>
									</Conditional>
								</div>

								<div className={classNames.commentHistoryItemTime}>
									{utils.formatTimeWithRelativeStamp(comment.commentDate)}
								</div>

								<div
									className={utils.concatClassNames([
										classNames.commentHistoryItemAction,
										isRejected
											? classNames.commentHistoryItemActionRejected
											: classNames.commentHistoryItemActionApproved,
									])}
								>
									<i
										className={`bi bi-${
											isRejected ? 'exclamation-triangle' : 'check-circle'
										}-fill`}
									></i>
								</div>
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};

export default ProjectComments;
